export default "__VITE_ASSET__DfdSZomy__"